import { Injectable, Injector } from '@angular/core';
import { DatePickerShowWeekService } from '@shared/components/date-picker-show-week/date-picker-show-week.service';
import { AllInterventionService } from '@shared/services/all-intervention.service';
import { BindHomeFullscreenService } from '@shared/services/bind-home-fullscreen.service';
import { CalendarService } from '@shared/services/calendar.service';
import { CampaignsService } from '@shared/services/campaigns.service';
import { CycleTVOService } from '@shared/services/cycleTVO.service';
import { DataService } from '@shared/services/data.service';
import { deactivateComponentService } from '@shared/services/desactivate.service';
import { MessagingChatService } from '@shared/services/messagingChat.service';
import { ParamedicalService } from '@shared/services/paramedical.service';
import { RoomService } from '@shared/services/room.service';
import { UserService } from '@shared/services/user.service';
import { UtilisService } from '@shared/services/utilis.service';
import { HrsuiteService } from 'src/app/hrsuite/hrsuite.service';
import { MiscellaneousService } from 'src/app/miscellaneous.service';
import { SurgeonOpeningsService } from 'src/app/operatingschedule/surgeon/surgeon-openings.service';
import { ParcoursIbodeService } from 'src/app/parcours-ibode/parcours-ibode.service';
import { ChatService } from './chat.service';
import { ChatGlobalSocketService } from './chatGlobalSocket.service';
import { HeaderService } from './header.service';
import { NavigationService } from './navigation.service';
import { RoutingStateService } from './routing-state.service';
import { SocketService } from './socket.service';
import { StorageService } from './storage.service';
import { SwCacheService } from './swCache.service';

@Injectable({
  providedIn: 'root',
})
export class ClearService {
  private _navigationService: NavigationService | null = null; // To provent circular dependencies between navigation service and authenticator service

  private get navigationService(): NavigationService {
    if (!this._navigationService) {
      this._navigationService = this.injector.get(NavigationService);
    }
    return this._navigationService;
  }

  constructor(
    private injector: Injector,
    private swCacheService: SwCacheService,
    private allInterventionService: AllInterventionService,
    private bindHomeFullscreenService: BindHomeFullscreenService,
    private calendarService: CalendarService,
    private campaignsService: CampaignsService,
    private cycleTVOService: CycleTVOService,
    private dataService: DataService,
    private deactivateService: deactivateComponentService,
    private messagingChatService: MessagingChatService,
    private paramedicalService: ParamedicalService,
    private roomService: RoomService,
    private utilisService: UtilisService,
    private datePickerShowWeekService: DatePickerShowWeekService,
    private chatService: ChatService,
    private chatGlobalSocketService: ChatGlobalSocketService,
    private headerService: HeaderService,
    private routingStateService: RoutingStateService,
    private parcoursIbodeService: ParcoursIbodeService,
    private surgeonOpeningsService: SurgeonOpeningsService,
    private storageService: StorageService,
    private miscellaneousService: MiscellaneousService,
    private userService: UserService,
    private hrsuiteService: HrsuiteService,
    private socketService: SocketService
  ) {}

  clearAll() {
    this.allInterventionService.clear();
    this.bindHomeFullscreenService.clear();
    this.calendarService.clear();
    this.campaignsService.clear();
    this.cycleTVOService.clear();
    this.dataService.clear();
    this.deactivateService.clear();
    this.messagingChatService.clear();
    this.paramedicalService.clear();
    this.roomService.clear();
    this.utilisService.clear();
    this.datePickerShowWeekService.clear();
    this.chatService.clear();
    this.chatGlobalSocketService.clear();
    this.headerService.clear();
    this.navigationService.clear();
    this.routingStateService.clear();
    this.storageService.clear();

    this.storageService.clearAllLocalStorageKeys(); // <-- Clear all keys
    this.storageService.clearUser(); // <-- Clear the store user

    this.parcoursIbodeService.clear();
    this.surgeonOpeningsService.clear();
    this.miscellaneousService.clear();
    this.userService.clear();
    this.hrsuiteService.clear();
    this.socketService.disconnect();

    this.swCacheService.deleteApiCache('api-stable-routes');
    this.storageService.clearAllLocalStorageKeys();
  }
}
